// extracted by mini-css-extract-plugin
export default {"dark":"WelcomeCard_dark__tVL7c","App":"WelcomeCard_App__5z+Bd","welcome":"WelcomeCard_welcome__dW+Gx"};